module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAUCAIAAADp3DFZAAAAXUlEQVQ4y2N4EMRGOWIYNYWWprzujaYcMfzHDf59//xp+/QX9e5AEsjGoxKfKa+6wuFuBrLJMeXP+xcPQrkQng/lAooMkCnU8RFpoZtwuphyxMC7QZtyNGoKLU0BAOe36V6WlYMhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ne.png
// module id = 896
// module chunks = 0